<img *ngIf="uri; else name" [src]="uri" />
<ng-template #name>
  <ng-content></ng-content>
</ng-template>
